import React from 'react'

import { useApolloClient } from '@apollo/client'
import { ExitToApp } from '@mui/icons-material'
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { useHistory } from 'react-router-dom'

import { useSelector } from '../../hooks/useSelector'

import { generalStyles } from './styles'

export const Logout = () => {
  const client = useApolloClient()
  const history = useHistory()
  const tenant = useSelector((state) => state.user?.tenantId)
  const handleLogout = () => {
    client.clearStore().then(() => {
      localStorage.removeItem('token')
      fetch('/auth/logout', {
        method: 'POST',
        redirect: 'follow',
        referrer: 'no-referrer',
      }).then((_res) => {
        history.push(`/${tenant}`)
      })
    })
  }

  return (
    <MenuItem onClick={handleLogout} sx={generalStyles.menuItem}>
      <ListItemIcon>
        <ExitToApp fontSize="small" />
      </ListItemIcon>
      <ListItemText sx={generalStyles.menuText} primary="Logout" />
    </MenuItem>
  )
}
